import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import "./View_Single_Wallet_History.css";
import { useDispatch, useSelector } from "react-redux";
import { getUserIncomeDetails } from "../../../../features/admin/auth/Slice";

const View_Single_Wallet_History = ({ show, handleClose, walletId }) => {
  const data = [
    { date: "20 Jan 2026", income: 1500, reward: 200 },
    { date: "18 Jan 2026", income: 500, reward: 50 },
    { date: "17 Jan 2026", income: 1500, reward: 150 },
  ];

  const subTotal = data.reduce((acc, item) => acc + item.income, 0);
  const total = data.reduce((acc, item) => acc + item.income + item.reward, 0);

  const dispatch = useDispatch();
  const userIncomeDetails = useSelector(
    (state) => state?.auth?.login?.getUserIncomeDetailsData,
  );
  const userIncomeDetail = userIncomeDetails?.records?.data;
  console.log(
    userIncomeDetails,
    "userIncomeDetailsuserIncomeDetailsuserIncomeDetails",
  );

  useEffect(() => {
    if (walletId) {
      dispatch(getUserIncomeDetails(walletId));
    }
  }, [dispatch, walletId]);

  return (
    <section className="product-modal-section View_Single_Wallet_History">
      <Modal
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="product-modal"
        size="lg"
      >
        <Modal.Body className="custom-modal-body invoice-container">
          {/* Header */}
          <div className="invoice-header">
            <h4>View History</h4>
            <p>Transaction Summary</p>
          </div>

          {/* Table */}
          <table className="invoice-table">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Date</th>
                <th>Reference User</th>
                <th>Income</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {userIncomeDetail && userIncomeDetail.length > 0 ? (
                userIncomeDetail.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>

                    <td>
                      {new Date(item.created_at).toLocaleDateString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </td>

                    <td>{item.reference_name || "N/A"}</td>

                    <td>₹{Number(item.amount).toLocaleString()}</td>

                    <td>₹{Number(item.amount).toLocaleString()}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Footer */}
          <div className="invoice-footer">
            <div className="row-item">
              <span>Subtotal:</span>
              <span>₹{userIncomeDetails?.sub_total_amount}</span>
            </div>
            <div className="row-item">
              <span>Reward:</span>
              <span>₹{userIncomeDetails?.reward}</span>
            </div>
            <div className="row-item total">
              <span>Total:</span>
              <span>₹{userIncomeDetails?.toal_amount}</span>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default View_Single_Wallet_History;
